import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import { getSeasons } from '../../../api';
import { Season } from '../../../types/season';
import HistoryIcon from './history-icon';

const SeasonHistory = () => {
  const [seasons, setSeasons] = useState<Season.Season[]>([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    getSeasons().then((res) => {
      setSeasons(res);
    })
  }, []);

  const renderStatus = (status: Season.SeasonStatus) => {
    switch (status) {
      case 'doing':
        return <div className={cn(styles.status, styles.doing)}>进行中</div>;
      case 'not_start':
        return <div className={cn(styles.status, styles.notStart)}>未开始</div>;
      case 'end':
        return <div className={cn(styles.status, styles.end)}>已结束</div>;
      default:
        return null;
    }
  }

  // 只取月份和日期
  const renderDate = (season: Season.Season) => {
    const start = season.start_day.slice(5, 10).replace('-', '.');
    const end = season.end_day.slice(5, 10).replace('-', '.');
    return <div className={styles.date}>{`${start} - ${end}`}</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title} onClick={() => setExpanded(true)}>
          <HistoryIcon />
          {expanded && '活动记录'}
        </div>
        {expanded && <div className={styles.close} onClick={() => setExpanded(false)}>收起</div>}
      </div>
      {expanded && (
        <div className={styles.content}>
          {seasons.map((season) => (
            <div className={styles.season} key={season.id}>
              <div className={styles.name}>{season.name}</div>
              <div className={styles.info}>
                {renderStatus(season.time_status)}
                {renderDate(season)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SeasonHistory;
